import { NgModule } from '@angular/core';
import { PHBHPFeaturePackageAuthorizationComponent } from './ph-bhp-feature-package-authorization.component';
import { PHBHPLoginComponent } from './ph-bhp-login/ph-bhp-login.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PhBhpForgetPasswordComponent } from './ph-bhp-forget-password/ph-bhp-forget-password.component';
import { PhBhpUserRegistrationComponent } from './ph-bhp-user-registration/ph-bhp-user-registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhBhpResetPasswordComponent } from './ph-bhp-reset-password/ph-bhp-reset-password.component';
import { PhBhpChangePasswordComponent } from './ph-bhp-change-password/ph-bhp-change-password.component';
// import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
// import { testDirective } from './testdirective';

// common libraries

import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module'; 
import { DropdownComponent } from './dropdown/dropdown.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import { ToastService } from '../services/toast.service';
@NgModule({
  declarations: [
    PHBHPFeaturePackageAuthorizationComponent, 
    PHBHPLoginComponent, 
    PhBhpForgetPasswordComponent, 
    PhBhpUserRegistrationComponent, 
    PhBhpResetPasswordComponent, 
    PhBhpChangePasswordComponent, 
    DropdownComponent,
    
    // testDirective
  ],
  imports: [
    PHBHPLayoutPackageModule, PHBHPLocalizePackageModule,FormsModule,ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    // PasswordStrengthBarModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    MatCardModule,
    MatTableModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatIconModule,
    BrowserModule,
    MatButtonModule,
    MatDividerModule,
    MatSlideToggleModule,
    PhBhpUiModule
  ],
  exports: [PHBHPFeaturePackageAuthorizationComponent,PHBHPLoginComponent, PhBhpForgetPasswordComponent, PhBhpUserRegistrationComponent, PhBhpResetPasswordComponent, PhBhpChangePasswordComponent, DropdownComponent],

})
export class PHBHPFeaturePackageAuthorizationModule { }
